import React, { useState, useEffect, useContext } from 'react';
import { IoCloseSharp } from "react-icons/io5";
import { motion } from 'framer-motion';
import ModalAlert from '../../modal/ModalAlert'
import ButtonWhite from '../../button/ButtonWhite';
import ButtonBack from '../../button/ButtonBack';
import InputAmount from '../../inputs/InputAmount';
import { AuthContext } from "../../../context/AuthContext"; // Asegúrate de importar el contexto correcto
import axios from 'axios';
import { FormatMontoPSE } from '../../../utils/Utils'
import { GoArrowBoth } from "react-icons/go";

import COP from '../../../assets/currency/copu.png'
import USD from '../../../assets/currency/usd.png'
import { IoIosArrowRoundDown } from "react-icons/io";
import { TbTransfer } from "react-icons/tb";

import { ReactComponent as Left } from '../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg'
import { ReactComponent as Info } from '../../../assets/IconsColurs/IconsGeneral/info.svg'
import { UtilContext } from '../../../context/UtilContext';

const ModalExchange = ({
    activeExchange,
    MovementsList,
    setActiveExchange,
    WalletBalanceHome,
    balanceWalletCop,
    balanceWalletUsd,
    currencyCoin = ""
}) => {
    const [title, setTitle] = useState("")
    const { longitude, latitude, IP } = useContext(UtilContext);

    const [description, setDescription] = useState("")
    const [id, setID] = useState("")
    const [loadingData, setLoadingData] = useState(false)
    const [loadingDataExchange, setLoadingDataExchange] = useState(false)

    const [TimeOFF, setTimeOFF] = useState(false);
    const [LoadingFinal, setLoadingFinal] = useState(false);


    const [ErrorTimeout, setErrorTimeout] = useState(0);

    const [ModalActive, setModalActive] = useState(false);
    const [controller, setController] = useState(null);
    const [error, setError] = useState("")
    const [errorAmount, setErrorAmount] = useState("")

    const [convert, setConvert] = useState(false)
    const { getAuthenticatedHeaders } = useContext(AuthContext)
    const [transitionBack, setTransitionBack] = useState(false)
    const [loading, setLoading] = useState(false)
    const [paso, setPaso] = useState('Exchange')
    const [priceDolar, setPriceDolar] = useState(4370.24)
    const [valueConvertCOP, setValueConvertCOP] = useState('')
    const [valueConvertUSD, setValueConvertUSD] = useState('')

    const [errorMessage, setErrorMessage] = useState('')
    const [errorExchange, setErrorExchange] = useState(false)
    const [butonActive, setButonActive] = useState(true)
    const [validate, setValidate] = useState(false)

    const [purchaseAmount, setPurchaseAmount] = useState()
    const [purchaseCommission, setPurchaseCommission] = useState('')
    const [purchaseCommissionIVA, setPurchaseCommissionIVA] = useState('')

    const [totalPurchase, setTotalPurchase] = useState('')

    const [counter, setCounter] = useState(30);
    const [counterError, setCounterError] = useState(30);


    const OnClose = () => {
        setValueConvertCOP("")
        setValueConvertUSD("")
        setPaso('Exchange')
        setTransitionBack(false)
        setActiveExchange(false)
    };

    const modalVariants = {
        hidden: transitionBack ? { x: "-100%", opacity: 0 } : { scale: 0, opacity: 0 },
        visible: transitionBack ? { x: 0, opacity: 1 } : { scale: 1, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
        exit: transitionBack ? { x: "100%", opacity: 0 } : { scale: 0.8, opacity: 0, transition: { duration: 0.5, ease: "easeInOut" } },
    };


    const stepVariants = {
        hidden: transitionBack ? { x: "-100%", opacity: 0 } : { x: "100%", opacity: 0 },
        visible: { x: 0, opacity: 1 },
        exit: transitionBack ? { x: "100%", opacity: 0 } : { x: "-100%", opacity: 0 },
    };


    const useCountdown = (initialTime = 30, dependency) => {
        useEffect(() => {
            setCounter(initialTime);
        }, [dependency, initialTime]); useEffect(() => {
            if (counter === 0) {
                setCounter(initialTime);
            } const interval = setInterval(() => { setCounter((prevCounter) => prevCounter - 1); }, 1000); return () => clearInterval(interval);
        }, [counter, initialTime]);
        return counter;
    };
    const Countdown = (initialTime = 30, dependency) => {
        useEffect(() => {
            setCounterError(initialTime);
        }, [dependency, initialTime]); useEffect(() => {
            if (counterError === 0) {
                setCounterError(initialTime);
            } const interval = setInterval(() => { setCounterError((prevCounter) => prevCounter - 1); }, 1000); return () => clearInterval(interval);
        }, [counterError, initialTime]);
        return counterError;
    };



    const countdown = useCountdown(30, paso === 'ConfirtExchange');
    const timeError = Countdown(ErrorTimeout)

    const BackExchange = () => {
        setPaso('Exchange')
        setTransitionBack(true)
        setValueConvertUSD("")
        setValueConvertCOP("")

        if (paso === 'Exchange') {
            OnClose()
        }
    }

    const NextExchange = () => {
        if (paso === "Exchange") {
            PreExchange()
            setTransitionBack(false)
        } else {
            ConfirmExchange()
        }
    }

    const PriceDolar = async () => {

        setLoadingData(true)
        await axios
            .post(`/api/exchange_rate`, {
                headers: await getAuthenticatedHeaders(),
                from: convert ? "USD" : "COP",
                to: !convert ? "USD" : "COP",
                amount: convert ? valueConvertUSD === "" ? "1" : valueConvertUSD : valueConvertCOP === "" ? "1" : valueConvertCOP,
                action: "SWAP"
            },
            )
            .then((response) => {
                if (response.data.status === 200) {
                    setPriceDolar(parseFloat(response.data.data.trm_rate))
                    if (!convert) {
                        setValueConvertUSD(response.data.data.target_amount)
                    } else {
                        setValueConvertCOP(response.data.data.target_amount)
                    }
                    setError("")
                } else if (response.data.status === 400) {
                    console.log(convert);

                    if (
                        response.data.data.code_transaction === "BalanceInsufficient" &&
                        !((convert && valueConvertUSD === "") || (!convert && valueConvertCOP === ""))
                    ) {
                        setError("Saldo Insuficiente. Ingresa otro valor o recarga tu billetera y vuelve a intentarlo.")

                    }


                }
            })
            .catch((error) => {

            });
        setLoadingData(false)
    }

    const PreExchange = async () => {

        setLoading(true)
        await axios
            .post(`/api/quote`, {
                headers: await getAuthenticatedHeaders(),
                from: convert ? "USD" : "COP",
                to: !convert ? "USD" : "COP",
                amount: convert ? valueConvertUSD === "" ? "1" : valueConvertUSD : valueConvertCOP === "" ? "1" : valueConvertCOP,
                action: "SWAP"
            },)
            .then((response) => {

                if (response.data.status === 201) {
                    setPurchaseAmount(response.data.data.data.source_amount)
                    setPurchaseCommission(response.data.data.data.fee_amount)
                    setPurchaseCommissionIVA(response.data.data.data.fee_iva_amount)
                    setTotalPurchase(response.data.data.data.source_amount)
                    setID(response.data.data.data.id)
                    setPaso('ConfirtExchange')
                    setCounter(30)
                } else if (response.data.status === 400) {
                    if (response?.data.data?.non_field_errors) {
                        const errorMessage = response.data.data.non_field_errors[0];

                        if (errorMessage.includes("Only can convert 5000.00 per day")) {
                            setError("El monto máximo diario de conversión es de 5000 dólares.")
                        } else {
                            console.log(errorMessage); // Para otros posibles errores
                        }
                    }

                }
                else if (response.data.status == 429) {



                    setErrorTimeout(response.data.data.retry_in_seconds)

                }

            })
            .catch((error) => {

            });

        setLoading(false)
    }
    const ConfirmExchange = async () => {
        setLoadingFinal(true)

        await axios
            .post(`/api/swap `, {
                headers: await getAuthenticatedHeaders(),
                from: convert ? "USD" : "COP",
                to: !convert ? "USD" : "COP",
                amount: convert ? valueConvertUSD === "" ? "1" : valueConvertUSD : valueConvertCOP === "" ? "1" : valueConvertCOP,
                action: "SWAP",
                quote_id: id,
                latitude: latitude,
                longitude: longitude,
                ip: IP
            },
            )
            .then((response) => {
                if (response.data.status === 201) {
                    WalletBalanceHome()
                    MovementsList()
                    setModalActive(true)
                    setError("")
                    setTitle("Transacción Exitosa")
                    setDescription("Tu intercambio se ha completado con éxito.")
                } else if (response.data.status === 400) {
                    console.log(response.data.data.message);

                    setError(response.data.data.message)

                }
            })
            .catch((error) => {

            });

    }

    useEffect(() => {
        if (convert) {
            setValueConvertUSD("");
        } else {
            setValueConvertCOP("");
        }
    }, [convert]);

    useEffect(() => {


        if ((convert && valueConvertCOP === '') || (convert && valueConvertUSD === '') || (!convert && valueConvertCOP === '') || (!convert && valueConvertUSD === '')) {


            setErrorMessage('');
            setErrorExchange(false);
            setValidate(false);
            setButonActive(true);
            return;
        }
        // Si pasa todas las validaciones
        setErrorMessage('');
        setErrorExchange(false);
        setValidate(true);

        // Controlar estado del botón
        if ((validate && valueConvertCOP !== '') || (validate && valueConvertUSD !== '')) {
            setButonActive(false);
        } else {
            setButonActive(true);
        }
    }, [valueConvertCOP, valueConvertUSD, convert]);

    useEffect(() => {
        if (!convert) {
            if ((valueConvertCOP) < 10000 && valueConvertCOP > 0) {
                setErrorAmount("El monto mínimo para operar es $10000 COP")
            } else {
                setErrorAmount("")
            }
        } else {
            if ((valueConvertUSD) < 10 && valueConvertUSD > 0) {
                setErrorAmount("El monto mínimo para operar es $10 USD")
            } else {
                setErrorAmount("")
            }
        }

    }, [valueConvertCOP, valueConvertUSD])

    useEffect(() => {
        if (!activeExchange) { return }
        WalletBalanceHome()

    }, []);
    useEffect(() => {
        if (!activeExchange) { return; }
        if (countdown === 0) {
            if (paso === "ConfirtExchange") {
                setTimeOFF(true)
            } else {
                PriceDolar()
            }
        }
    }, [countdown])


    useEffect(() => {
        if (!activeExchange) { return; }

        // Cancelar la petición anterior si existe
        if (controller) {
            controller.abort();
        }

        // Crear un nuevo AbortController para la petición actual
        const newController = new AbortController();
        setController(newController);

        // Esperar 500ms antes de ejecutar la petición (debounce)
        const timeout = setTimeout(() => {
            PriceDolar(newController.signal);
        }, 500);

        return () => clearTimeout(timeout); // Limpiar el timeout si los valores cambian rápido


    }, [!convert ? valueConvertCOP : valueConvertUSD]);
    useEffect(() => {
        if (!activeExchange) return
        PriceDolar()
    }, [activeExchange])

    useEffect(() => {
        if (paso === "Exchange") {
            setValueConvertCOP("")
            setValueConvertUSD("")
        }
        setTimeOFF(false)
    }, [paso])

    useEffect(() => {
        if (counterError === 0) {

            setErrorTimeout(0)
        }
    }, [counterError])


    const CloseModal = () => {
        setLoadingFinal(false)
        WalletBalanceHome()
        setErrorTimeout(null)
        setValueConvertCOP("")
        setValueConvertUSD("")
        setPaso("Exchange")
        setModalActive(false)
        setActiveExchange(false)
    }
    const ValidateDisable = () => {


        if (paso === "Exchange") {
            console.log("timeError == 0", timeError);

            if (timeError > 0) {
                return true

            }

            return !convert ? valueConvertCOP === "" : valueConvertUSD === "";
        }

        if (paso === "ConfirtExchange") {
            return TimeOFF;
        }

        return false; // Caso por defecto si 'paso' no es ninguno de los dos
    };



    useEffect(() => {
        if (!activeExchange) return;

        if (currencyCoin !== "") {
            if (currencyCoin === "COP") {
                setConvert(false)
            } else {
                setConvert(true)
            }
        }
    }, [currencyCoin, activeExchange])




    return (
        <>
            {ModalActive && <ModalAlert title={title} description={description} onClick={CloseModal} labelButtonWhite={"Listo"} />}

            {activeExchange && <>

                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50 p-4">
                    <motion.div
                        className="bg-[#26262D] rounded-lg shadow-lg w-full max-w-2xl flex flex-col justify-between overflow-hidden max-h-[90vh]"
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        {/* Encabezado del modal */}
                        <div className="p-4 md:p-6">
                            <div className="w-full flex flex-row justify-between items-center">
                                <p className="text-base md:text-lg font-semibold text-white">
                                    {paso === 'Exchange' ? 'Convertir' : 'Confirmar la conversión'}
                                </p>
                                <IoCloseSharp
                                    size={24}
                                    color={"#b7b7b9"}
                                    onClick={OnClose}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        {/* Contenido dinámico del modal */}
                        <div className="flex-grow px-4 md:px-6 overflow-y-auto">
                            {paso === 'Exchange' && <motion.div
                                className="bg-[#26262D]"
                                key="step1"
                                variants={modalVariants}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeOut" }}>
                                <div className='w-full flex flex-col gap-4 md:gap-[1.10rem]'>
                                    <div className='w-full py-1'>
                                        <p className='text-sm md:text-base font-bold text-[#B7B7B9]'>
                                            Saldo disponible: <strong className='text-white'>{!convert ? FormatMontoPSE(balanceWalletCop, true) : FormatMontoPSE(balanceWalletUsd, true, '.')}</strong>
                                        </p>
                                    </div>
                                    <InputAmount
                                        error={errorAmount}
                                        title="Envias"
                                        currency={convert ? 'USD' : 'COP'}
                                        value={!convert ? valueConvertCOP : valueConvertUSD}
                                        onChange={(e) => (!convert ? setValueConvertCOP(e) : setValueConvertUSD(e))}
                                        errorMessage={errorAmount}
                                    />

                                    <div className='w-full flex flex-row justify-between items-center gap-4 md:gap-8'>
                                        <div className="relative h-full ml-2 md:ml-6">
                                            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-[2px] bg-[#5E5E63]">
                                                <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-[#5E5E63] rounded-full"></div>
                                            </div>
                                        </div>
                                        {!loadingDataExchange &&
                                            <div className='flex-1 flex flex-col gap-1 justify-center py-2 md:py-4'>
                                                <div className='flex flex-row gap-1 items-center flex-wrap'>
                                                    <p className='text-sm md:text-base text-[#E4E4E4]'>
                                                        Tarifa estimada $1 USD= {FormatMontoPSE(priceDolar, true, '.')} + Comisiones
                                                    </p>
                                                    <Info className="w-5 h-5 md:w-6 md:h-6 text-white" />
                                                </div>
                                                <p className='text-sm md:text-base text-[#8A8A8E]'>
                                                    Recotizando en {countdown} segundos
                                                </p>
                                            </div>
                                        }
                                        {loadingDataExchange &&
                                            <div className="spinner-border-white animate-spin w-6 h-6 md:w-8 md:h-8 border-2 border-white border-t-transparent rounded-full">
                                            </div>
                                        }
                                        <div className='w-8 md:w-10 flex items-center justify-center'>
                                            <button
                                                className='w-8 h-8 md:w-10 md:h-10 bg-[#5E5E6329] hover:bg-white rounded-xl group flex items-center justify-center'
                                                onClick={() => setConvert(!convert)}
                                            >
                                                <TbTransfer
                                                    className={`text-white group-hover:text-black transition-transform duration-500 ease-in-out ${convert ? 'rotate-[270deg]' : 'rotate-[90deg]'}`}
                                                    size={24}
                                                />
                                            </button>
                                        </div>
                                    </div>

                                    <InputAmount
                                        title="Recibes"
                                        error={error}
                                        errorMessage={error}
                                        loading={loadingData}
                                        readOnly={true}
                                        currency={convert ? 'COP' : 'USD'}
                                        value={convert ? valueConvertCOP : valueConvertUSD}
                                    />
                                </div>
                            </motion.div>}

                            {timeError > 0 &&
                                <p className='text-[#FF928B] text-sm md:text-base'>
                                    {`Has realizado un exchange recientemente. Inténtalo nuevamente en ${timeError}s`}
                                </p>
                            }

                            {paso === 'ConfirtExchange' && <motion.div
                                className="bg-[#26262D]"
                                key="step2"
                                variants={stepVariants}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                <div className='w-full flex flex-col gap-4'>
                                    <div className='w-full bg-[#2B2B33] rounded-xl p-4 md:p-6'>
                                        <div className='grid grid-cols-3 gap-2'>
                                            <div className='flex flex-col items-center gap-2'>
                                                <img src={convert ? USD : COP} alt="currency" className='w-8 h-8 md:w-[35px] md:h-[35px]' />
                                                <p className='text-sm md:text-base text-[#8A8A8E]'>Envías</p>
                                                <p className='text-lg md:text-[22px] font-bold text-white'>
                                                    {!convert ? FormatMontoPSE(valueConvertCOP) : FormatMontoPSE(valueConvertUSD, true, '.')}
                                                </p>
                                            </div>
                                            <div className='flex items-center justify-center'>
                                                <IoIosArrowRoundDown className='rotate-[-90deg] w-8 h-8 md:w-12 md:h-12 text-white' />
                                            </div>
                                            <div className='flex flex-col items-center gap-2'>
                                                <img src={convert ? COP : USD} alt="currency" className='w-8 h-8 md:w-[35px] md:h-[35px]' />
                                                <p className='text-sm md:text-base text-[#8A8A8E]'>Recibes</p>
                                                <p className='text-lg md:text-[22px] font-bold text-white'>
                                                    {convert
                                                        ? (valueConvertCOP ? FormatMontoPSE(valueConvertCOP, true, ',') : '--')
                                                        : (valueConvertUSD ? FormatMontoPSE(valueConvertUSD, true, ".") : '--')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='flex flex-col gap-2'>
                                        <p className='text-sm md:text-base font-bold'>Resumen</p>
                                        <div className='bg-[#2B2B33] rounded-xl p-4 md:p-6 flex flex-col gap-2'>
                                            <div className='flex justify-between items-center'>
                                                <p className='text-sm md:text-base text-[#8A8A8E]'>Tasa de intercambio</p>
                                                <p className='text-sm md:text-base font-bold text-white'>
                                                    $1 USD = {!TimeOFF ? FormatMontoPSE(priceDolar, true, ',') : "--"}
                                                </p>
                                            </div>
                                            <div className='flex justify-between items-center'>
                                                <p className='text-sm md:text-base text-[#8A8A8E]'>Monto a Enviar</p>
                                                <p className='text-sm md:text-base font-bold text-white'>
                                                    {TimeOFF ? `$-- ${convert ? "USD" : "COP"}` : !convert ? FormatMontoPSE(purchaseAmount, true, ',') : FormatMontoPSE(purchaseAmount, true, '.')}
                                                </p>
                                            </div>
                                            <div className="border-t border-dashed border-[#8A8A8E] my-2"></div>
                                            <div className='flex justify-between items-center'>
                                                <p className='text-sm md:text-base text-[#8A8A8E]'>Total a recibir</p>
                                                <p className='text-sm md:text-base font-bold text-white'>
                                                    {TimeOFF ? `$-- ${convert ? "USD" : "COP"}` : !convert ? FormatMontoPSE(valueConvertUSD, true, '.') : FormatMontoPSE(valueConvertCOP, ',')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>}
                        </div>

                        {/* Botones en la parte inferior */}
                        <div className="p-4 md:p-6 flex flex-col md:flex-row gap-4 justify-between">
                            <ButtonBack
                                Icon={paso === 'ConfirtExchange' ? Left : ''}
                                onClick={BackExchange}
                                label={paso === 'Exchange' ? 'Cancelar' : 'Volver'}
                                className="w-full md:w-fit"
                            />
                            <ButtonWhite
                                loading={paso === 'Exchange' ? loading : LoadingFinal}
                                isDisabled={ValidateDisable()}
                                readOnly={butonActive}
                                onClick={NextExchange}
                                label={paso === 'Exchange' ? 'Convertir' : !TimeOFF ? 'Confirmar conversión ' + countdown + 's' : "Confirmar conversión 0s"}
                                className="w-full md:w-fit"
                            />
                        </div>
                    </motion.div>
                </div>



            </>}
        </>
    );
};

export default ModalExchange;

